import { useState, useCallback } from 'react';
import { initializeAddCredBannerState, setLocalStorageForAddCredBanner } from '../utils/utils';

export const usePayerCredBanner = (isEligible: boolean) => {
  const [showBanner, setShowBanner] = useState(() => initializeAddCredBannerState(isEligible));

  const handleCloseBanner = useCallback(() => {
    setShowBanner(false);
    setLocalStorageForAddCredBanner();
  }, []);

  return { showBanner, handleCloseBanner };
};
